import { render, staticRenderFns } from "./ModalImportTabsTemplates.vue?vue&type=template&id=7963866a"
import script from "./ModalImportTabsTemplates.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalImportTabsTemplates.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports